// extracted by mini-css-extract-plugin
export var standaloneTable = "_jt-0";
export var standaloneTableWithBodyFill = "_jt-1";
export var withExtraHeader = "_jt-2";